import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {ButtonProps} from '@mantine/core';
import {FlexiAddButton} from '@flexinet/ui-components';
import {AddFormDrawer} from '../drawers/AddFormDrawer.tsx';

// The button stays mounted while its drawer is open, so the toolbar keeps its Add entry
// and focus returns to it on close (§7, §13). The drawer mounts per open, so the form
// starts empty each time.
export const AddRecordButton = (props: ButtonProps) => {
    const [drawerOpened, setDrawerOpened] = useState(false);

    return (
        <>
            <FlexiAddButton
                data-testid='provider-mappings-add'
                onClick={() => setDrawerOpened(true)}
                {...props}
            >
                {I18n.get('Add Mapping')}
            </FlexiAddButton>
            {drawerOpened && (
                <AddFormDrawer
                    opened={drawerOpened}
                    onClose={() => setDrawerOpened(false)}
                />
            )}
        </>
    );
};
